import { Globe } from "lucide-react";
import { useI18n, SUPPORTED_LANGS } from "@/i18n";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="lang-switcher">
      <Globe className="h-4 w-4 text-muted-foreground" />
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger className="h-8 w-[130px] rounded-full bg-brema-card text-xs" data-testid="lang-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {SUPPORTED_LANGS.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>{l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
